import React from 'react';
import PropTypes from 'prop-types';

const EditPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M22.922 3.082a1.936 1.936 0 0 1 1.379-.562 2.17 2.17 0 0 1 1.534.647l2.998 2.997c.828.828.867 2.133.086 2.914l-1.061 1.061c-.196.195-.522.185-.729-.022L21.883 4.87c-.207-.207-.216-.533-.021-.728l1.06-1.06zM19.6 6.404a.471.471 0 0 1 .339-.138c.137 0 .278.055.386.163l5.247 5.246c.206.207.217.532.024.726L12.297 25.698c-.192.194-.517.183-.724-.024l-5.247-5.247c-.207-.207-.218-.531-.024-.725L19.6 6.404zM4.146 21.782a.502.502 0 0 1 .708 0l5.364 5.364a.5.5 0 0 1-.354.854H4.5a.5.5 0 0 1-.5-.5v-5.364c0-.132.053-.259.146-.354z"
    />
  );
};

EditPath.propTypes = {
  fill: PropTypes.string,
};

export default EditPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/interaction/edit.jsx